import React from 'react';

import { Svg } from '@lglp/components';

import styles from './DefaultPressReleaseIcon.module.scss';

const DefaultPressReleaseIcon: React.FC<DefaultPressReleaseProps> = ({
  className,
  ...rest
}) => {
  return (
    <Svg
      id="icon_communiques"
      width="111.901"
      height="114.721"
      viewBox="0 0 111.901 114.721"
      className={className}
      {...rest}
    >
      <g transform="translate(2.75 2.75)">
        <g transform="translate(-558.251 -1902.755)">
          <line
            className={styles.cls1}
            x2="38.13"
            transform="translate(582.012 1929.586)"
          />
          <line
            className={styles.cls1}
            x2="25.232"
            transform="translate(582.012 1948.7)"
          />
          <line
            className={styles.cls1}
            x2="25.142"
            transform="translate(582.012 1967.812)"
          />
          <line
            className={styles.cls1}
            x2="38.13"
            transform="translate(582.012 1986.925)"
          />
          <path
            className={styles.cls1}
            d="M502.881,112.465v45.492a7.929,7.929,0,0,1-7.928,7.93H426.179a7.929,7.929,0,0,1-7.928-7.93V64.594a7.928,7.928,0,0,1,7.928-7.928h68.756a7.927,7.927,0,0,1,7.928,7.913l.017,26.9"
            transform="translate(140 1846.089)"
          />
          <path
            className={styles.cls2}
            d="M465.1,108.441l14.689-4.484a1.992,1.992,0,0,0,.868-3.27l-9.488-10.075a1.992,1.992,0,0,0-3.325.7l-5.2,14.559a1.991,1.991,0,0,0,2.456,2.575"
            transform="translate(158.559 1860.278)"
          />
          <path
            className={styles.cls3}
            d="M469.138,101.34l6.626,6.973a1.983,1.983,0,0,0,2.786.088l25.906-24.059a1.981,1.981,0,0,0,.1-2.81l-6.635-7.058a1.983,1.983,0,0,0-2.8-.092l-25.9,24.143A1.981,1.981,0,0,0,469.138,101.34Z"
            transform="translate(160.062 1852.937)"
          />
        </g>
      </g>
    </Svg>
  );
};

type DefaultPressReleaseProps = {
  className?: string;
};

export default DefaultPressReleaseIcon;
